<template>
  <div
    v-if="file && posterUrl"
    class="a-cover overflow-hidden bg-black bg-full"
    :style="{ backgroundImage: posterUrl && `url('${posterUrl}')` }"
  >
    <transition name="fade">
      <video
        ref="video"
        class="a-cover bg-full object-cover transition-opacity duration-500 ease-in-out"
        :src="file.url"
        :width="file.width"
        :height="file.height"
        :type="file.mime_type"
        :poster="posterUrl"
        autoplay
        muted
        loop
        playsinline
        :style="{
          backgroundImage: posterUrl && `url('${posterUrl}')`,
          opacity: videoReady ? 1 : 0
        }"
        @play="played"
        @pause="paused"
        @canplaythrough="canPlayThrough"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { bus } from '@/main'

export default {
  name: 'BackgroundVideo',

  props: {
    videoFieldGroup: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    player: null,
    videoReady: false,
    isPaused: null
  }),

  computed: {
    file() { return this.videoFieldGroup.mp4 ?? false },
    poster() { return this.videoFieldGroup.poster ?? {} },
    posterUrl() {
      const image = this.poster ?? {}
      const sizes = image.sizes ?? {}
      return sizes.large
    },
  },

  mounted() {
    // Video
    this.player = this.$refs.video
    if (this.player) {
      // Disable casting on player
      this.player.disableRemotePlayback = true
    }
  },

  methods: {
    togglePlaystate() {
      const { player } = this
      if (!player) { return }
      if (player.paused) {
        player.play()
      } else {
        player.pause()
      }
    },
    played() {
      this.isPaused = false
      this.$emit('played')
    },
    paused() {
      this.isPaused = true
      this.$emit('paused')
    },
    canPlayThrough() {
      this.videoReady = true
      this.$emit('canplaythrough')
    }
  }
}
</script>

<!-- Essex / Keele / Sheefield / Imperial -->
